import React, { useEffect, useState } from 'react';
import Show from '../../../../Show/Show';
import _ from 'lodash';
import { COLORS } from '../../../../../config/designSystem/Colors';
import { Dropdown } from 'react-native-element-dropdown';
import { Feather } from '@expo/vector-icons';
import { IAnswerModel } from '../../../../../state/stores/Question/AnswerModel';
import { ParagraphMBold, ParagraphMRegularTextStyle } from '../../../../../config/designSystem/typography';
import { SnapshotOrInstance, SnapshotOut } from 'mobx-state-tree';
import {StyleSheet, View} from 'react-native';
import { useAvailableDimensions } from '../../../../../hooks/ui/useAvailableDimensions';

interface AnswerDropdownProps {
  answers: SnapshotOrInstance<IAnswerModel>[];
  onPress: (answer: SnapshotOrInstance<IAnswerModel>) => void;
  flag: boolean;
  search: boolean;
  label?: string;
  initSelection?: IAnswerModel | null;
}

const AnswerDropdown = ({
  onPress,
  initSelection,
  search,
  label,
  ...props
}: AnswerDropdownProps) => {

  // the Dropdown component can modify the data which is illegal with mobx models
  // use cloneDeep to workaround this
  const [answers, setAnswers] = useState(_.cloneDeep(props.answers || []));
  useEffect(() => {
    setAnswers(_.cloneDeep(props.answers || []));
  }, [props.answers]);
  const [selected, setSelected] = useState(initSelection ?? answers[0]);
  const {width}= useAvailableDimensions();
  const onChange : (val: SnapshotOut<IAnswerModel>) => void = val => {
    onPress(val);
    setSelected(val);
  };

  const answer0 = answers[0];
  useEffect(() => {
    setSelected(initSelection ?? answer0);
  }, [initSelection, answer0]);

  const MARGIN_HORIZONTAL = 16;
  const WIDTH =Math.min(width- 2*MARGIN_HORIZONTAL, 400);
  const disabled = answers.length < 2;

  return (
    <View style={ {width: WIDTH, alignSelf:'center'}}>
      <Show when={label}>
        <ParagraphMBold>{label}</ParagraphMBold>
      </Show>
      <View
        style={[
          styles.dropdownContainer,
          {
            backgroundColor: disabled ? COLORS.surface.tertiary : COLORS.surface.primary,
          }
        ]}
      >
        <Dropdown
          accessibilityLabel={label}
          style={[styles.dropdown, {width: WIDTH}]}
          placeholderStyle={styles.placeholderStyle}
          selectedTextStyle={ParagraphMRegularTextStyle({color: disabled ? COLORS.content.tertiary : COLORS.content.primary})}
          itemTextStyle={ParagraphMRegularTextStyle({color: COLORS.content.primary})}
          data={answers}
          search={search}
          maxHeight={300}
          labelField="wording"
          valueField="_id"
          value={selected}
          onChange={onChange}
          renderRightIcon={() => <Feather name='chevron-down' size={24} color={COLORS.content.primary} style={{marginLeft: 8}} />}
          disable={disabled}
        />
      </View>
    </View>
  );
};


export default AnswerDropdown;

const styles = StyleSheet.create({
  dropdownContainer: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border.primary,
    shadowColor: 'rgba(16, 24, 40, 0.05)', // Full color without alpha
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2
  },
  dropdown: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border.primary,
    shadowColor: 'rgba(16, 24, 40, 1)', // Full color without alpha
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
    alignSelf: 'center',
    paddingVertical: 10,
    paddingHorizontal: 14,
    backgroundColor: COLORS.surface.primary,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
  },
});
